export default "__VITE_ASSET__B2q3HW2m__"